<cap-list-loader
  [defaultText]="'gemaessAmtlicherBewertung'"
  [hasRight]="hasRight"
  [listLoader]="listLoader"
  [showTotal]="false"
  class="externe-daten">
  <div class="cap-list-loader-title">
    <ng-content select="[name=title]"></ng-content>
  </div>
  <div class="cap-list-loader-content">
    <table class="cap-table-detail">
      <thead>
        <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
      </thead>
      <tbody>
        <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
      </tbody>
    </table>
  </div>
</cap-list-loader>

<ng-template #tableHeaders>
  <tr>
    <th>{{ "Eigentum" | translate }}</th>
    <th>{{ "Anteil" | translate }}</th>
    <th>{{ "neskoab.AmtlicherWert" | translate }}</th>
  </tr>
</ng-template>

<ng-template #tableRows>
  @for (item of listLoader?.items; track item) {
    <tr>
      <td>
        {{ eigentumsform }}
        <cap-kompakt-neskoab-grundstueck [item]="item"></cap-kompakt-neskoab-grundstueck>
      </td>
      <td>
        @if (item.anteilZaehler && (item.anteilZaehler !== "1" || item.anteilNenner !== "1")) {
          <span> {{ item.anteilZaehler }}/{{ item.anteilNenner | decimalHochkomma }} </span>
        }
      </td>
      <td>
        {{ item.amtlicherWert | betrag: true }}
      </td>
    </tr>
  }
</ng-template>
